<template>
  <div class="HistoryFooter">
    <div class="HistoryFooter-container">
      <div class="HistoryFooter-info">
        <div class="HistoryFooter-label">
          Ir a la próxima epoca
        </div>
        <div class="HistoryFooter-years">
          {{ yearRange }}
        </div>
      </div>
      <div class="HistoryFooter-icon" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    range: Object,
  },
  computed: {
    yearRange() {
      const { range } = this;
      const [yearA, yearB] = range.yearRange;
      return `${yearA}-${yearB}`;
    },
  },
};
</script>

<style lang="stylus" scoped>
@import './HistoryFooter.styl';
</style>
